<template>
  <div class="w-full">
    <component :blogKeys="blogKeys" :blogs="blogs" :editObj="editObj" :is="activeBlogMod"/>
  </div>
</template>

<script>
  import firebase from "firebase";
  import {db} from '@/db'
  import {eventBus} from "../../eventbus";
  import BlogAdd from "./BlogAdd";
  import BlogEdit from "./BlogEdit";
  import BlogContent from "./BlogContent";

  export default {
    name: "BlogIndex",
    components: {
      BlogAdd,
      BlogEdit,
      BlogContent
    },
    data: () => ({
      blogKeys: [],
      blogs: [],
      editObj: {},
      activeBlogMod: 'BlogContent'
    }),
    firebase: {
      blogs: db.ref('blog_post').orderByChild('title'),
    },
    watch: {
      blogs() {
        this.getKeys()
      }
    },
    methods: {
      getKeys() {
        let keys = []
        firebase.database().ref('blog_post/').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let key = {key: childSnapshot.key}
            let value = childSnapshot.val()
            keys.push({...key, ...value})

          })
        })
        this.blogKeys = keys
      },
      listener() {
        eventBus.$on('AddBlog', () => this.activeBlogMod = 'BlogAdd')
        eventBus.$on('AllBlog', () => this.activeBlogMod = 'BlogContent')
        eventBus.$on('EditBlog', (x) => {
          this.editObj = x;
          this.activeBlogMod = 'BlogEdit'

        })
      }
    },
    created() {
      this.listener()
    }

  }
</script>

<style scoped>

</style>
